// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from 'sweetalert2';





// Arma el enlace tel: con indicativo. Si el número ya trae "+" se respeta; si es un celular colombiano
// de 10 dígitos (sin indicativo, como se guarda en el perfil) se le antepone +57.
function enlaceTelefono(telefono, pais) {
    const crudo = String(telefono || "").trim();
    if (!crudo || crudo === "NA") return null;
    const digitos = crudo.replace(/[^\d]/g, "");
    if (!digitos) return null;
    if (crudo.startsWith("+")) return `tel:+${digitos}`;
    if ((pais || "Colombia") === "Colombia" && digitos.length === 10) return `tel:+57${digitos}`;
    return `tel:${digitos}`;
}

// contraparte: { nombre, telefono, pais } — viene de /obtener-reserva-y-servicio solo si quien consulta
// está autenticado, la reserva está pagada y activa, y no hay reclamo abierto (ver backend/routes/reservas.js).
// telefonosAdmin: [{ rol: "Comprador" | "Vendedor", usuario }] — solo en la vista de admin (soloLectura):
// muestra AMBOS teléfonos siempre, sin importar el estado de la reserva, para que soporte pueda contactarlos.
function ChatReserva({ reserva, usuario, mensajesTodos, quienEs, soloLectura = false, contraparte = null, telefonosAdmin = null }) {
    const [mensaje, setMensaje] = useState("");

    const mensajes = Array.isArray(mensajesTodos)
        ? [...mensajesTodos].sort((a, b) => new Date(a?.createdAt || 0) - new Date(b?.createdAt || 0))
        : [];
    const idUsuarioLogueado = usuario?.idUsuario;
    const estaEnDisputa = reserva?.reclamo?.abierto === true || ["abierto", "en_revision"].includes(reserva?.reclamo?.estado);
    const puedeEnviarMensaje = !estaEnDisputa && (reserva?.estado === "hold" || reserva?.estado === "confirmado");

    // Llamada: solo con la reserva pagada y activa. Si ya finalizó (completada, cancelada, expirada) o está
    // en reclamo, el botón queda deshabilitado con el motivo.
    const rolContraparte = quienEs === "Vendedor" ? "comprador" : "vendedor";
    const reservaActiva  = reserva?.estado === "confirmado" || (reserva?.estado === "hold" && reserva?.tipoHold === "confirmacionHorario");
    const hrefLlamada    = enlaceTelefono(contraparte?.telefono, contraparte?.pais);
    const puedeLlamar    = reservaActiva && !estaEnDisputa && !!hrefLlamada;
    const motivoSinLlamada = estaEnDisputa
        ? "La llamada está bloqueada mientras Zervicy revisa el reclamo."
        : !reservaActiva
            ? "La reserva ya finalizó: la llamada ya no está disponible."
            : `El ${rolContraparte} no tiene un teléfono registrado. Escríbele por el chat.`;

    async function enviarMensaje(e) {
        e.preventDefault();

        if (!puedeEnviarMensaje) {
            Swal.fire({
                icon: "info",
                title: estaEnDisputa ? "Reserva en reclamo" : "Chat cerrado",
                text: estaEnDisputa
                    ? "Esta reserva está en reclamo. El chat queda bloqueado mientras Zervicy revisa el caso."
                    : "Solo puedes enviar mensajes mientras la reserva esté pendiente o confirmada.",
                confirmButtonColor: "var(--azul-logo-fondo)",
            });
            return;
        }

        const mensajeLimpio = mensaje.trim();

        if (!mensajeLimpio) {
            Swal.fire({ icon: "info", title: "Mensaje vacío", text: "Escribe un mensaje para contactar al proveedor.", confirmButtonColor: "var(--azul-logo-fondo)", });
            return;
        }

        const resMens = await axios.post("/enviar-mensaje", {
            params: { mensajeLimpio, reserva, usuario, enviadoPor: usuario.modo }
        });

        await Swal.fire({ icon: "success", title: "Éxito", text: resMens?.data?.mensaje, customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' } });
        window.location.reload();
        return;
    }

    function formatearFecha(fecha) {
        if (!fecha) return "";

        try {
            return new Date(fecha).toLocaleString("es-CO", {
                day: "2-digit",
                month: "short",
                hour: "numeric",
                minute: "2-digit",
            });
        }
        catch {
            return "";
        }
    }

    //console.log("mensajes desde chat: ", mensajesTodos);
    //console.log("reserva desde chat: ", reserva);

    return (
        <div className="card border-0 shadow-sm rounded-4 mt-4">
            <div className="card-body p-4">
                <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
                    <div>
                        <h2 className="h5 fw-bold text-dark mb-1">Contactar al {quienEs === "Vendedor" ? "Comprador" : "Vendedor"} </h2>
                        <p className="text-muted mb-0" style={{ fontSize: "0.95rem", lineHeight: 1.5 }}>
                            Usa este espacio para coordinar detalles de la reserva.
                        </p>
                        <div className={`alert ${estaEnDisputa ? "alert-danger" : "alert-warning"} rounded-4 border-0 mt-3 mb-0 py-2 px-3`} style={{ fontSize: "0.88rem", lineHeight: 1.45 }}>
                            <strong>{estaEnDisputa ? "Reserva en reclamo:" : "Importante:"}</strong>{" "}
                            {estaEnDisputa
                                ? "el chat está bloqueado mientras Zervicy revisa el caso. Usaremos la información existente de la reserva y la conversación para llegar a una solución."
                                : "esta conversación podrá ser revisada por Zervicy en caso de disputas, devoluciones o solicitudes de soporte relacionadas con la reserva."
                            }
                        </div>
                    </div>

                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                        style={{ width: 44, height: 44, background: "rgba(var(--azul-logo-claro-rgb), 0.10)", color: "var(--azul-logo-claro)" }}
                    >
                        <i className="bi bi-chat-dots" style={{ fontSize: "1.3rem" }}></i>
                    </div>
                </div>

                {/* ADMIN: teléfonos de comprador y vendedor, siempre visibles */}
                {soloLectura && Array.isArray(telefonosAdmin) && telefonosAdmin.length > 0 ? (
                    <div className="rounded-4 border p-3 mb-3 d-flex flex-column gap-3" style={{ background: "var(--color-bg-surface)" }}>
                        {telefonosAdmin.map(({ rol, usuario: persona }) => {
                            const telefono = (persona?.telefono && persona.telefono !== "NA") ? String(persona.telefono) : "";
                            const href     = enlaceTelefono(telefono, persona?.pais);
                            const nombre   = [persona?.nombre, persona?.apellido].filter((v) => v && v !== "NA").join(" ") || persona?.username || "";
                            return (
                                <div key={rol} className="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                                    <div style={{ minWidth: 0 }}>
                                        <div className="fw-semibold text-dark" style={{ fontSize: "0.95rem" }}>
                                            <i className="bi bi-telephone me-2" style={{ color: "var(--azul-logo-claro)" }}></i>
                                            {rol}{nombre ? ` · ${nombre}` : ""}
                                        </div>
                                        <small className="text-muted d-block">{telefono || "Sin teléfono registrado"}</small>
                                    </div>
                                    {href ? (
                                        <a href={href} className="btn btn-outline-primary rounded-pill px-4 fw-semibold flex-shrink-0">
                                            <i className="bi bi-telephone-fill me-2"></i>Llamar
                                        </a>
                                    ) : (
                                        <button type="button" className="btn btn-outline-secondary rounded-pill px-4 fw-semibold flex-shrink-0" disabled>
                                            <i className="bi bi-telephone-x me-2"></i>No disponible
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ) : null}

                {/* LLAMAR A LA CONTRAPARTE (no aplica en la vista de solo lectura del admin) */}
                {soloLectura ? null : (
                    <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap rounded-4 border p-3 mb-3" style={{ background: "var(--color-bg-surface)" }}>
                        <div style={{ minWidth: 0 }}>
                            <div className="fw-semibold text-dark" style={{ fontSize: "0.95rem" }}>
                                <i className="bi bi-telephone me-2" style={{ color: "var(--azul-logo-claro)" }}></i>
                                Llamar al {rolContraparte}
                            </div>
                            <small className="text-muted d-block" style={{ lineHeight: 1.4 }}>
                                {puedeLlamar
                                    ? `${contraparte?.nombre ? contraparte.nombre + " · " : ""}${contraparte.telefono}`
                                    : motivoSinLlamada}
                            </small>
                        </div>

                        {puedeLlamar ? (
                            <a href={hrefLlamada} className="btn btn-outline-primary rounded-pill px-4 fw-semibold flex-shrink-0">
                                <i className="bi bi-telephone-fill me-2"></i>Llamar
                            </a>
                        ) : (
                            <button type="button" className="btn btn-outline-secondary rounded-pill px-4 fw-semibold flex-shrink-0" disabled title={motivoSinLlamada}>
                                <i className="bi bi-telephone-x me-2"></i>No disponible
                            </button>
                        )}
                    </div>
                )}

                <div
                    className="rounded-4 border p-3 mb-3"
                    style={{ background: "var(--color-bg-surface-alt)", maxHeight: 300, overflowY: "auto" }}
                >
                    {mensajes.length > 0 ? (
                        <div className="d-flex flex-column gap-3">
                            {mensajes.map((msg, index) => {
                                const esMio = String(msg?.idEmisor || "") === String(idUsuarioLogueado || "");

                                return (
                                    <div
                                        key={msg?._id || msg?.idMensaje || index}
                                        className={`d-flex ${esMio ? "justify-content-end" : "justify-content-start"}`}
                                    >
                                        <div
                                            className="rounded-4 px-3 py-2"
                                            style={{
                                                maxWidth: "82%",
                                                background: esMio ? "var(--azul-logo-fondo)" : "var(--blanco)",
                                                color: esMio ? "var(--blanco)" : "var(--gris-900)",
                                                border: esMio ? "1px solid var(--azul-logo-fondo)" : "1px solid var(--color-border)",
                                            }}
                                        >
                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                <span className="fw-semibold" style={{ fontSize: "0.82rem" }}>
                                                    {esMio ? "Tú" : quienEs === "Vendedor" ? "Comprador" : "Vendedor"}
                                                </span>
                                                <span style={{ fontSize: "0.75rem", opacity: 0.75 }}>
                                                    {formatearFecha(msg?.createdAt)}
                                                </span>
                                            </div>
                                            <p className="mb-0" style={{ fontSize: "0.95rem", lineHeight: 1.45, whiteSpace: "pre-wrap" }}>
                                                {msg?.mensaje || "Mensaje sin contenido"}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <div
                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                style={{ width: 54, height: 54, background: "var(--color-bg-surface)", color: "var(--color-text-secondary)", border: "1px solid var(--color-border)" }}
                            >
                                <i className="bi bi-chat-left-text" style={{ fontSize: "1.5rem" }}></i>
                            </div>
                            <p className="fw-semibold text-dark mb-1">Aún no hay mensajes</p>
                            <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                                Escríbele al {quienEs === "Vendedor" ? "Comprador" : "Vendedor"}  para coordinar cualquier detalle del servicio.
                            </p>
                        </div>
                    )}
                </div>

                {soloLectura ? (
                    <p className="text-muted small mb-0 mt-2 text-center">
                        <i className="bi bi-eye me-1"></i>Vista de solo lectura — los administradores no pueden enviar mensajes.
                    </p>
                ) : (
                    <form onSubmit={enviarMensaje}>
                        <label className="form-label fw-semibold text-dark">Mensaje para el {quienEs === "Vendedor" ? "Comprador" : "Vendedor"} </label>
                        <textarea
                            className="form-control rounded-4 mb-3"
                            rows="2"
                            maxLength="1000"
                            placeholder="Ej: Hola, quiero confirmar la hora y la dirección del servicio."
                            value={mensaje}
                            onChange={(e) => setMensaje(e.target.value)}
                            disabled={!puedeEnviarMensaje}
                        />

                        <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
                            <small className="text-muted">
                                {mensaje.length}/1000 caracteres
                            </small>

                            <button
                                type="submit"
                                className="btn btn-primary rounded-pill px-4 fw-semibold"
                                disabled={!puedeEnviarMensaje}
                                title={estaEnDisputa ? "El chat está bloqueado porque la reserva está en reclamo" : !puedeEnviarMensaje ? "El chat está cerrado para esta reserva" : "Enviar mensaje"}
                            >
                                <i className="bi bi-send me-2"></i>
                                {puedeEnviarMensaje ? "Enviar mensaje" : estaEnDisputa ? "Chat bloqueado" : "Chat cerrado"}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}



export default ChatReserva;